<script>
import { appointmentMetaFields as metaFields } from "./metaFields";
import { Validator } from "@/plugins/validator";
export default {
    name: "DischargeAppointmentModal",

    data() {

        return {
            appointment: {
                id: 0,
                encounterID: 0,
                appointmentDate: window.moment().format(`YYYY-MM-DD`),
                time: window.moment().format('HH:MM'),
                comment: ``,
                userName: this.$root.username,
                cancelled: false,
            },
            departments: [],
            doctors: [],
            errors: [],
        };
    },

    props: {

        patient: Object,
        showModal: Boolean,
        appointments: Array,
    },

    watch: {

        showModal() {
            if(!this.showModal) return;
            this.$root.loading = true;
            Promise.all([ this.fetchDepartments(), this.fetchDoctors(), ]).then(() => {
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },

    methods: {

        fetchDepartments() {

            return this.$http.get(`MasterData/GetClinics`).then(({ data }) => {
                this.departments = data;
            }).catch(() => {});
        },

        fetchDoctors() {

            return this.$http.get(`Shared/GetActiveConsultants`).then(({ data }) => {
                    this.doctors = data;
                }).catch(() => {});
        },

        saveData() {
            const appointment = {
                ...this.appointment,
                patientID: this.patient.patienT_ID,
                visitNo: this.patient.visitNo,
                encounterID: 0,
            };

            new Validator(appointment, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.errors = [];
                this.$http.post(`MedicalFile/PatientAppointments`, appointment).then(() => {
                    this.$emit(`refresh`);
                    this.appointment = {
                        id: 0,
                        encounterID: 0,
                        appointmentDate: window.moment().format(`YYYY-MM-DD`),
                        time: window.moment().format('HH:MM'),
                        comment: ``,
                        userName: this.$root.username,
                        cancelled: false,
                    };
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => { this.errors = errors; });
        },
    }
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-3/4 w-11/12 min-h-64">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Patient Appointments</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label for="grid-doctor" class="label-control">Doctor:</label>
            <v-select class="bg-white text-xs" 
                :options="doctors"
                :reduce="doc => doc.names"
                label="names"
                v-model="appointment.doctor"
            />
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'doctor').length">
                    {{ errors.filter(error => error.field == 'doctor')[0].message }}</p>
        </div>
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label for="grid-clinic" class="label-control">Clinic:</label>
            <v-select class="bg-white text-xs" 
                :options="departments"
                :reduce="dep => dep.clinic"
                label="clinic"
                v-model="appointment.clinic"
            />
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'clinic').length">
                    {{ errors.filter(error => error.field == 'clinic')[0].message }}</p>
        </div>
        <div class="md:w-1/5 sm:w-full p-tiny">
            <label for="grid-date" class="label-control">Date:</label>
            <input type="date" v-model="appointment.appointmentDate" 
                id="grid-date" class="input-control input-sm text-xs">
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'appointmentDate').length">
                    {{ errors.filter(error => error.field == 'appointmentDate')[0].message }}</p>
        </div>
        <div class="md:w-1/5 sm:w-full p-tiny">
            <label for="grid-time" class="label-control">Time:</label>
            <input type="time" v-model.trim="appointment.time" 
                id="grid-time" class="input-control input-sm text-xs">
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'time').length">
                    {{ errors.filter(error => error.field == 'time')[0].message }}</p>
        </div>
        <div class="md:w-1/12 sm:w-full text-right p-tiny mt-4">
            <button 
                class="btn-sm btn-primary rounded text-xs" 
                @click.stop="saveData">
                    <i class="fa fa-save"></i> Save</button>
        </div>
        <div class="w-full overflow-auto">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-white text-sm">
                   <tr class="w-full flex">
                       <th class="p-tiny flex-1">Doctor</th>
                       <th class="p-tiny flex-1">Clinic</th>
                       <th class="p-tiny flex-1">Date</th>
                       <th class="p-tiny flex-1">Time</th>
                       <th class="p-tiny flex-1">Action</th>
                   </tr> 
                </thead>
                <tbody 
                    class="bg-gray-100 text-sm flex flex-col items-center overflow-auto" 
                    style="max-height:35vh;">
                    <tr v-for="(app, idx) in appointments" class="w-full flex" :key="idx">
                        <td class="p-tiny flex-1">{{ app.doctor }}</td>
                        <td class="p-tiny flex-1">{{ app.clinic }}</td>
                        <td class="p-tiny flex-1">{{ app.appointmentDate | dateFormat }}</td>
                        <td class="p-tiny flex-1">{{ app.startTime }}</td>
                        <td class="p-tiny flex-1">
                            <button 
                                class="btn-sm btn-primary text-xs" 
                                @click.prevent="appointment={ 
                                    ...app, appointmentDate: $root.formatDate(app.appointmentDate), 
                                    time: app.startTime }">
                                        <i class="fa fa-edit"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>
